import InfoMapLayer from './InfoMapLayer';
export default InfoMapLayer;
